import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BiPlus } from 'react-icons/bi';
import { BsPersonWorkspace } from 'react-icons/bs';

export default function WorkSpace() {
  const [sellers, setSellers] = useState([]); 
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSearch, setShowSearch] = useState(false); 
  const [showAddForm, setShowAddForm] = useState(false);
  const [newUser, setNewUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    dateOfBirth: '',
    password: '',
  });

  const [isSlidingDivVisible, setIsSlidingDivVisible] = useState(false);

  const toggleSlidingDiv = () => {
    setIsSlidingDivVisible(!isSlidingDivVisible);
  };

  // Fetch all users from backend
  const fetchSellers = async () => {
    try {
      const { data } = await axios.get('http://localhost/mineralBackend/sellers');
      console.log(data.data)
      setSellers(data.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Fetch users on component mount
  useEffect(() => {
    fetchSellers();
  }, []);

  // Handle search operation
  const handleSearch = () => {
    const results = sellers.filter(
      (user) =>
        user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results); // Update search results
  };

  // Add new user to the backend
  const handleAddUser = async () => {
    try {
      await axios.post('http://localhost/mineralBackend/addUser', newUser);
      alert('User added successfully!');
      setShowAddForm(false);
      fetchSellers(); 
    } catch (error) {
      console.error('Error adding user:', error);
      alert('Failed to add user.');
    }
  };

  return (
    <div className="p-4 shadow rounded-lg">
      <div className="flex justify-between">
        <div className="flex items-center font-bold text-lg">
          <BsPersonWorkspace />
          <span className="ml-2">WorkSpace</span>
        </div>
        <button
          onClick={() => {
            setShowSearch(true); // Show search UI
            setShowAddForm(false); // Hide Add Form
          }}
          className="flex items-center border p-2 rounded-lg"
        >
          <BiPlus /> Add
        </button>
      </div>
      <hr className="my-3" />

      

      {/* Search Section */}
      {showSearch && (
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search user by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-2 border rounded mb-2"
          />
          <button
            onClick={handleSearch}
            className="bg-blue-500 text-white p-2 rounded w-full"
          >
            Search
          </button>
        </div>
      )}

      {/* Display Search Results */}
      {showSearch && searchResults.length > 0 && (
        <ul className="max-h-40 overflow-y-auto border rounded mb-4">
          {searchResults.map((user) => (
            <li key={user.id} className="p-2 cursor-pointer hover:bg-gray-100">
              {user.firstName} {user.lastName} - {user.email}
            </li>
          ))}
        </ul>
      )}

      {/* Add New User Button */}
      {showSearch && searchResults.length === 0 && !showAddForm && (
        <button
          onClick={() => setShowAddForm(true)}
          className="bg-green-500 text-white p-2 rounded w-full"
        >
          Add New User
        </button>
      )}

      {/* Add User Form */}
      {showAddForm && (
        <div className="bg-white p-6 rounded shadow-lg">
          <h3 className="font-bold mb-2">Add New User</h3>
          <input
            type="text"
            placeholder="First Name"
            value={newUser.firstName}
            onChange={(e) =>
              setNewUser({ ...newUser, firstName: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <input
            type="text"
            placeholder="Last Name"
            value={newUser.lastName}
            onChange={(e) =>
              setNewUser({ ...newUser, lastName: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <input
            type="email"
            placeholder="Email"
            value={newUser.email}
            onChange={(e) =>
              setNewUser({ ...newUser, email: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <input
            type="text"
            placeholder="Phone Number"
            value={newUser.phoneNumber}
            onChange={(e) =>
              setNewUser({ ...newUser, phoneNumber: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <input
            type="text"
            placeholder="Gender"
            value={newUser.gender}
            onChange={(e) =>
              setNewUser({ ...newUser, gender: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <input
            type="date"
            placeholder="Date of Birth"
            value={newUser.dateOfBirth}
            onChange={(e) =>
              setNewUser({ ...newUser, dateOfBirth: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <input
            type="password"
            placeholder="Password"
            value={newUser.password}
            onChange={(e) =>
              setNewUser({ ...newUser, password: e.target.value })
            }
            className="w-full p-2 border rounded mb-2"
          />
          <button
            onClick={handleAddUser}
            className="w-full bg-blue-500 text-white p-2 rounded"
          >
            Add User
          </button>
        </div>
      )}

      
    </div>
  );
}
